module.exports = parcelRequire.resolve("i4ei0");